export default "__VITE_ASSET__Dipu$oT6__"